module.exports = __webpack_public_path__ + "img/CULTURA_H_Traco.4930e8f1.png";